import { ENDPOINTS } from "app/app-config";

export const callAPI = async (authInfo, API, body) => {
  const response = await fetch(getEndpoint(authInfo, API), {
    method: "POST",
    headers: {
      token: authInfo.securityToken,
      api: API.name,
      method: "POST",
    },
    ...(body && { body: JSON.stringify(body) }),
  });

  if (response.ok) {
    return await response.json();
  } else {
    const message = await response.text();
    throw Error(message);
  }
};

const getEndpoint = (authInfo, { resource, service }) =>
  `${ENDPOINTS[authInfo.realm][authInfo.domain][service]}${resource}`;
